var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"va-icon",class:[_vm.name, _vm.iconClass],style:(_vm.iconStyle)},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }